import { useGetUploadsQuery } from 'features/mediaLibrary/mediaApi';
import { useActiveOrganisation } from 'hooks/useActiveOrganisation';
import { useMemo } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { FOLDER_TRASH } from 'pages/media_library/config/settings';

const emptyArray = [];

export function useGetUploads(folder) {
    const currentOrganisationId = useActiveOrganisation();

    const filterUploads = useMemo(() => {
        // Return a unique selector instance for this page so that
        // the filtered results are correctly memoized
        return createSelector(
            (res) => res.data,
            (_data, folder) => folder,
            (data, folder) => {
                if (data) {
                    if (folder === undefined) {
                        // return all
                        return data.filter((upload) => upload.deletedAt === null);
                    }

                    if (folder === FOLDER_TRASH) {
                        return data.filter((upload) => upload.deletedAt !== null);
                    }

                    return data.filter((upload) => upload.folder === folder && upload.deletedAt === null);
                }

                return emptyArray;
            },
        );
    }, []);

    const { uploads } = useGetUploadsQuery(currentOrganisationId, {
        selectFromResult: (result) => ({
            uploads: filterUploads(result, folder),
        }),
    });

    return uploads;
}
